<div class="sx-filter__expansion-panel">
    <mat-checkbox [(ngModel)]="selection.selected" (change)="updateFilter($event)">{{selection.name}}</mat-checkbox>
</div> 



